import { selectDocumentTitle } from '../../selectors/seo';
import { IBrowserHistoryState } from '../../types/browserHistory';
import { TThunkAction } from '../../types/redux';
import { isBrowser } from '../../utils/isBrowser';
import { triggerHeaderRegionChanged } from '../../utils/events/';
import { selectCurrentRegion } from '../../selectors/region';
import { setRegionCookie } from '../../utils/cookie/setRegionCookie';
import { changeDocumentTitle } from '../../utils/document';
import { setQueryParamsFromFilters } from '../../utils/filters';
import { updatePagination } from '../pagination';

export const updateBrowserHistory =
  (historyUrl?: string): TThunkAction<void> =>
  (dispatch, getState) => {
    const state = getState();
    const { filters } = state;
    const currentRegion = selectCurrentRegion(state);
    const documentTitle = selectDocumentTitle(state);

    if (isBrowser()) {
      const newUrl = historyUrl ?? setQueryParamsFromFilters(filters);

      if (window.location.href !== newUrl.toString()) {
        triggerHeaderRegionChanged(currentRegion);
        setRegionCookie(currentRegion);
        changeDocumentTitle(documentTitle);

        if (!historyUrl) {
          window.history.pushState({ filters, url: window.location.href } as IBrowserHistoryState, '', newUrl);
          dispatch(updatePagination());
        }
      }
    }
  };
